import React from "react";
import "./TagPage.css";
import emailjs from '@emailjs/browser';


const handleSubmit = async (e) => {
  e.preventDefault();

  const form = e.target;
  const button = form.querySelector("button");

  const name = form.name.value;
  const email = form.email.value;
  const phone = form.phone.value;
  const city = form.city.value;
  const message = form.message.value;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = "Enviando...";

  try {
    const serviceID = "service_lxg5sht";
    const templateID = "template_epehkcc";
    const publicKey = "4f0iRLKGvmXsd0ASA";

    const params = {
      from_name: name,
      reply_to: email,
      message: `
NUEVO MENSAJE DESDE MOTIDIGITAL.COM

Nombre: ${name}
Correo: ${email}
Teléfono: ${phone}
Ciudad: ${city}

Mensaje:
${message}
      `,
    };

    await emailjs.send(serviceID, templateID, params, publicKey);

    button.textContent = "Enviado ✔";
    form.reset();

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 3000);

  } catch (error) {
    console.error(error);
    button.textContent = "Error ✖";

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2500);
  }
};


const TagPage = () => {
    return (
        <div className="main-container-tag">
            {/* === ELASTITAG SECTION === */}
            <div className="elasti-container">
                <div className="elasti-card">
                    <div className="elasti-left">
                        <h2>
                            ElastiTag®:<br />
                            La etiqueta inteligente que<br />
                            transforma tus productos,<br />
                            ahora en Moti.
                        </h2>

                        <p className="elasti-desc">
                            Duraderas, personalizables y perfectas para<br />
                            destacar tu marca en el punto de venta.
                        </p>

                        <a href="https://wa.me/+5213323104081?text=Hola,%20me%20interesa%20comprar%20ElastiTag%C2%AE"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="elasti-btn">
                            <img src="/images/elasti/whats.svg" alt="WhatsApp" />
                            Cotiza por WhatsApp
                        </a>
                    </div>

                    <div className="elasti-right">
                        <div className="elasti-circle"></div>

                        <img src="/images/elasti/bottle1.png" className="bottle bottle1" />
                        <img src="/images/elasti/bottle2.png" className="bottle bottle2" />
                        <img src="/images/elasti/bottle3.png" className="bottle bottle3" />
                        <img src="/images/elasti/bottle4.png" className="bottle bottle4" />
                        <img src="/images/elasti/bottle5.png" className="bottle bottle5" />
                    </div>
                </div>
            </div>

            <div className="elastitag-fragmento">
                <div className="text-container-tag">

                    <p className="et-descripcion">
                        ElastiTag® es mucho más que una simple etiqueta. Se trata de un accesorio flexible, atractivo y
                        totalmente personalizable que se ajusta a prácticamente cualquier producto sin necesidad de
                        adhesivos ni cuerdas. Su diseño permite que tu marca capture la atención del consumidor justo en
                        el momento de la compra.
                    </p>

                    <p className="et-subtitulo">
                        Explora los modelos <br />
                        de ElastiTag® disponibles
                    </p>

                </div>

                <div className="modelos-elastitag">
                    <div className="modelo">
                        <img src="/images/elasti/tags/Tag.svg" alt="Tag" />
                        <p className="modelo-label">Tag</p>
                    </div>

                    <div className="modelo">
                        <img src="/images/elasti/tags/Band.svg" alt="Band" />
                        <p className="modelo-label">Band</p>
                    </div>

                    <div className="modelo ">
                        <img src="/images/elasti/tags/Marquee.svg" alt="Marquee" />
                        <p className="modelo-label">Marquee</p>
                    </div>

                    <div className="modelo">
                        <img src="/images/elasti/tags/Tote.svg" alt="Tote" />
                        <p className="modelo-label">Tote</p>
                    </div>

                    <div className="modelo">
                        <img src="/images/elasti/tags/Tab.svg" alt="Tab" />
                        <p className="modelo-label">Tab</p>
                    </div>
                </div>

            </div>
            <div className="elastitag-reasons">
                <h2 className="reasons-title">5 razones para elegir ElastiTag®</h2>

                <div className="reasons-grid">
                    <div className="reason-card">
                        <div className="reason-holder">
                            <img src="/images/elasti/icons/resistencia.svg" alt="" className="reason-icon" />
                            <h3>Resistencia garantizada</h3>
                        </div>
                        <p className="reason-p">
                            Fabricadas en materiales de alta durabilidad, son resistentes al agua,
                            desgarros y condiciones de refrigeración.
                        </p>
                    </div>

                    <div className="reason-card">
                        <div className="reason-holder">
                            <img src="/images/elasti/icons/versatilidad.svg" alt="" className="reason-icon" />
                            <h3>Versatilidad de aplicación</h3>
                        </div>
                        <p className="reason-p">
                            Se adaptan a botellas, empaques flexibles, racimos de frutas, productos
                            de cuidado personal y más.
                        </p>
                    </div>

                    <div className="reason-card">
                        <div className="reason-holder">

                            <img src="/images/elasti/icons/facil.svg" alt="" className="reason-icon" />
                            <h3>Fácil de usar</h3>
                        </div>
                        <p className="reason-p">
                            Se aplican manualmente o con maquinaria especializada, ahorrando tiempo
                            y reduciendo errores.
                        </p>
                    </div>

                    <div className="reason-card">
                        <div className="reason-holder">
                            <img src="/images/elasti/icons/personalizacion.svg" alt="" className="reason-icon" />
                            <h3>Personalización</h3>
                        </div>
                        <p className="reason-p">
                            Elige entre múltiples formas, tamaños, colores y acabados premium para
                            que tu marca luzca única.
                        </p>
                    </div>

                    <div className="reason-card">
                        <di className="reason-holder">
                            <img src="/images/elasti/icons/sostenibilidad.svg" alt="" className="reason-icon" />
                            <h3>Sostenibilidad</h3>
                        </di>
                        <p className="reason-p">
                            Con el programa TagBack®, las etiquetas usadas se reciclan para darles
                            una segunda vida.
                        </p>
                    </div>
                </div>
            </div>
            <div className="benefits-section">
                <h2 className="benefits-title">¿Qué usos le puedes dar a ElastiTag®?</h2>

                <div className="benefit-item item-1">
                    <p className="benefit-text">
                        Lanzar un producto con un impacto visual único y memorable.
                    </p>
                    <img src="/images/elasti/bottle2.png" alt="Impacto visual" className="benefit-img right" />
                </div>

                <div className="benefit-item item-2">
                    <img src="/images/elasti/bottle4.png" alt="Información exclusiva" className="benefit-img left" />
                    <p className="benefit-text">
                        Añade información exclusiva o promociones directamente en tu empaque.
                    </p>
                </div>

                <div className="benefit-item item-3">
                    <p className="benefit-text">
                        Diferenciarte con un accesorio que no solo comunica, sino que también decora.
                    </p>
                    <img src="/images/elasti/bottle3.png" alt="Diferenciación" className="benefit-img center" />
                </div>
            </div>

            <div className="contact-section-wrapper">
                {/* CTA */}
                <div className="cta-elastitag">
                    <div className="cta-info">
                        <h3>¿Quieres comprar tus<br />ElastiTag®?</h3>
                        <p>Contacta a uno de nuestros ejecutivos.</p>
                        <a href="https://wa.me/+5213323104081?text=Hola,%20me%20interesa%20comprar%20ElastiTag®" target="_blank" rel="noopener noreferrer" class="cta-btn">Comprar ahora</a>
                    </div>

                    {/* grupo imágenes izquierda */}
                    <div className="cta-figure left-figure" aria-hidden>
                        <img
                            src="/images/elasti/bottle4.png"
                            alt=""
                            className="cta-img left img-1"
                        />
                        <img
                            src="/images/elasti/bottle5.png"
                            alt=""
                            className="cta-img left img-2"
                        />
                    </div>

                    {/* grupo imágenes derecha */}
                    <div className="cta-figure right-figure" aria-hidden>
                        <img
                            src="/images/elasti/bottle7.png"
                            alt=""
                            className="cta-img right img-1"
                        />
                        <img
                            src="/images/elasti/bottle1.png"
                            alt=""
                            className="cta-img right img-2"
                        />
                    </div>
                </div>

                {/* CONTACTO (titulo + grid) */}
                <div className="contact-section">
                    <h2 className="contact-title">Pongámonos en <span className="accent">contacto</span></h2>

                    <div className="contact-grid">
                        {/* FORM */}
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-row">
                                <label>
                                    Nombre*
                                    <input type="text" name="name" />
                                </label>

                                <label>
                                    Correo*
                                    <input type="email" name="email" />
                                </label>
                            </div>

                            <div className="form-row">
                                <label>
                                    Teléfono*
                                    <input type="tel" name="phone" />
                                </label>

                                <label>
                                    Ciudad*
                                    <input type="text" name="city" />
                                </label>
                            </div>

                            <label className="full">
                                Tu mensaje*
                                <textarea name="message" rows="6" />
                            </label>

                            <button type="submit" className="btn-submit">Enviar mensaje</button>
                        </form>

                        {/* INFO DERECHA */}
                        <aside className="contact-info">
                            <div className="info-card">
                                <h3 className="info-title">Dirección</h3>
                                <p className="info-text">
                                    Calle 1 No. 1375 - 5, Zona Industrial<br />
                                    C.P. 44960 Guadalajara,<br />
                                    Jalisco, México.
                                </p>

                                <h3 className="info-title">Contacto</h3>
                                <p className="info-text">
                                    Teléfono: <strong>33 2310 4081</strong><br />
                                    Correo: <strong>contacto@motidigital.com</strong>
                                </p>

                                <h3 className="info-title">Horario</h3>
                                <p className="info-text">
                                    Lunes a Viernes 9:00 - 17:30<br />
                                    Sábado: 9:00 - 14:00
                                </p>
                            </div>

                            <div className="social-strip">
                                <div className="social-text">Mantente conectado</div>
                                <div className="social-icons">
                                    <a href="https://www.facebook.com/MotiDigitalMX" target="_blank" className="social-link facebook">
                                        <img src="/images/elastitote/icon/icon1.svg" alt="Facebook" />
                                    </a>
                                    <a href="https://www.instagram.com/motidigital/" target="_blank"  className="social-link instagram">
                                        <img src="/images/elastitote/icon/icon2.svg" alt="Instagram" />
                                    </a>
                                    <a href="https://www.tiktok.com/@motistore" target="_blank" className="social-link tiktok">
                                        <img src="/images/elastitote/icon/icon3.svg" alt="TikTok" />
                                    </a>
                                    <a href="https://www.tiktok.com/@motistore" target="_blank" className="social-link youtube">
                                        <img src="/images/elastitote/icon/icon4.svg" alt="YouTube" />
                                    </a>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default TagPage;
